import _classCallCheck from "/codebuild/output/src3701839561/src/proteket-gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/codebuild/output/src3701839561/src/proteket-gatsby/node_modules/@babel/runtime/helpers/esm/createClass.js";
import { defaultStorage } from '@aws-amplify/core';
import { refreshAuthTokens } from '../utils/refreshAuthTokens.mjs';
import { DefaultTokenStore } from './TokenStore.mjs';
import { TokenOrchestrator } from './TokenOrchestrator.mjs'; // Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var CognitoUserPoolsTokenProvider = /*#__PURE__*/function () {
  function CognitoUserPoolsTokenProvider() {
    _classCallCheck(this, CognitoUserPoolsTokenProvider);

    this.authTokenStore = new DefaultTokenStore();
    this.authTokenStore.setKeyValueStorage(defaultStorage);
    this.tokenOrchestrator = new TokenOrchestrator();
    this.tokenOrchestrator.setAuthTokenStore(this.authTokenStore);
    this.tokenOrchestrator.setTokenRefresher(refreshAuthTokens);
  }

  _createClass(CognitoUserPoolsTokenProvider, [{
    key: "getTokens",
    value: function getTokens() {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        forceRefresh: false
      },
          forceRefresh = _ref.forceRefresh;

      return this.tokenOrchestrator.getTokens({
        forceRefresh: forceRefresh
      });
    }
  }, {
    key: "setKeyValueStorage",
    value: function setKeyValueStorage(keyValueStorage) {
      this.authTokenStore.setKeyValueStorage(keyValueStorage);
    }
  }, {
    key: "setAuthConfig",
    value: function setAuthConfig(authConfig) {
      this.authTokenStore.setAuthConfig(authConfig);
      this.tokenOrchestrator.setAuthConfig(authConfig);
    }
  }]);

  return CognitoUserPoolsTokenProvider;
}();

export { CognitoUserPoolsTokenProvider };